import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import UnitPicker, { renderUnit } from '../UnitPicker/UnitPicker';
import * as Styled from '../../Sizes.styles';
export default (function () {
  var _useState = useState(1),
      _useState2 = _slicedToArray(_useState, 2),
      activeUnit = _useState2[0],
      changeUnit = _useState2[1];

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(UnitPicker, {
    activeUnit: activeUnit,
    changeUnit: changeUnit
  }), /*#__PURE__*/React.createElement(Styled.ResponsiveWrapper, null, /*#__PURE__*/React.createElement(Styled.Table, null, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "\xA0"), /*#__PURE__*/React.createElement("th", {
    className: "th"
  }, "UK"), /*#__PURE__*/React.createElement("th", {
    className: "th"
  }, "EU"), /*#__PURE__*/React.createElement("th", {
    className: "th"
  }, "Bust"), /*#__PURE__*/React.createElement("th", {
    className: "th"
  }, "Waist"), /*#__PURE__*/React.createElement("th", {
    className: "th"
  }, "Hip")), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td row-title",
    rowSpan: "2"
  }, "Small"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "8"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "36"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, renderUnit([85, 34], activeUnit)), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, renderUnit([71.5, 28], activeUnit)), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, renderUnit([91, 36], activeUnit))), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "10"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "38"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, renderUnit([89, 35], activeUnit)), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, renderUnit([75.5, 30], activeUnit)), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, renderUnit([95, 38], activeUnit))), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td row-title",
    rowSpan: "2"
  }, "Medium"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "12"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "40"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, renderUnit([93, 37], activeUnit)), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, renderUnit([79.5, 32], activeUnit)), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, renderUnit([99, 39], activeUnit))), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "14"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "42"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, renderUnit([98, 39], activeUnit)), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, renderUnit([84.5, 34], activeUnit)), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, renderUnit([104, 41], activeUnit))), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td row-title",
    rowSpan: "2"
  }, "Large"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "16"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "44"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, renderUnit([104, 41], activeUnit)), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, renderUnit([90.5, 36], activeUnit)), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, renderUnit([110, 44], activeUnit))), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "18"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "46"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, renderUnit([110, 44], activeUnit)), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, renderUnit([97.5, 39], activeUnit)), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, renderUnit([116, 46], activeUnit))), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td row-title",
    rowSpan: "3"
  }, "X Large"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "20"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "48"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, renderUnit([115, 46], activeUnit)), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, renderUnit([104.5, 42], activeUnit)), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, renderUnit([112, 49], activeUnit))), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "22"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "50"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, renderUnit([122, 49], activeUnit)), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, renderUnit([111.5, 45], activeUnit)), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, renderUnit([128, 51], activeUnit))), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "24"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "52"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, renderUnit([128, 51], activeUnit)), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, renderUnit([118.5, 47], activeUnit)), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, renderUnit([134, 53], activeUnit)))))));
});